import config, { ConfigConstants } from '@px/config';

export default {
  init: function (options) {
    this.baseUrl = options.baseUrl;
    const homeUrl = config.get(ConfigConstants.HOME_PAGE);
    this.urls = {
      basketApiGet: `${this.baseUrl}/api/basket`,
      basketApiPatch: `${this.baseUrl}/api/basket`,
      basketApiPatchGroup: `${this.baseUrl}/api/updateGroup`,
      basketApiDelete: `${this.baseUrl}/api/remove`,
      splitApi: `${this.baseUrl}/api/split`,
      restrictedDomainApi: `${homeUrl}/api/selected/domains/restricted`
    };
  }
};
